export default "__VITE_ASSET__02db060b__"